import { useEffect, useState } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Intro } from "@/components/Intro";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Services } from "@/components/Services";
import { InteriorStyles } from "@/components/InteriorStyles";
import { Projects } from "@/components/Projects";
import { Videos } from "@/components/Videos";
import { Founder } from "@/components/Founder";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import Admin from "@/pages/Admin";

const HomePage = ({ introDone, setIntroDone }) => (
  <div className="App min-h-screen bg-paper">
    <Intro onDone={() => setIntroDone(true)} />
    {introDone && (
      <>
        <Navbar />
        <main>
          <Hero />
          <Marquee />
          <Services />
          <InteriorStyles />
          <Projects />
          <Videos />
          <Founder />
          <Contact />
        </main>
        <Footer />
        <WhatsAppButton />
      </>
    )}
    <Toaster position="bottom-right" />
  </div>
);

function App() {
  const [introDone, setIntroDone] = useState(false);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage introDone={introDone} setIntroDone={setIntroDone} />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
